export default "__VITE_ASSET__CWz2K3g2__"